/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffairbaevent/style.css';
import FormStructure from './thecateredaffairbaevent/form_structure';

export default FormStructure;